import React from 'react';

/*
 * The list card of the Invoices and Bank payouts tabs: a sunken header (title, count, the list's own
 * actions on the right, an optional note line), then the list.
 */
const ListCard = ({ title, sub, acts, note, className = '', children }) => (
  <div className={`tp-card ${className}`.trim()}>
    <div className="tp-card-hd">
      <span className="tp-card-hd-main">
        <span className="tp-card-hd-title" role="heading" aria-level={3}>
          {title}
        </span>
        {sub ? <span className="tp-card-hd-sub">{sub}</span> : null}
      </span>
      {acts ? <span className="tp-card-hd-acts">{acts}</span> : null}
      {note ? <span className="tp-card-hd-note">{note}</span> : null}
    </div>
    {children}
  </div>
);

// "3 shown" / "50+ shown" for a cursor list once it has loaded.
export const shown_text = (list) =>
  list && list.status === 'ready' ? `${list.rows.length}${list.next ? '+' : ''} shown` : '';

export default ListCard;
